var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import * as React from "react";
import { Tabs, TabsTrigger, TabsList, TabsContent } from "framework/tabs/tabs";
import { getFieldErrorsAsString } from "framework/validation/validatableentity";
import { useEventPlanning_Actions, useEventPlanning_Event, useEventPlanning_Officials_AllOfficialsList, useEventPlanning_Tabs } from "./store";
import { BaseDataKeysToCheck, DetailedDataKeysToCheck, EventEditBaseDataView, EventEditDetailedDataView } from "./event/view";
import { CompetitionsEdit } from "./competitions/view";
import { OfficialsEdit } from "./officials/view";
import { useUIContext } from "common/uicontext/store";
import { cls_button_width, cls_form_area } from "./view.css";
import { HBox, VBox } from "framework/structural_components/hbox_vbox";
import { EventState } from "../../entity";
import { Button, Intent } from "framework/controls/button";
import { cls_colorMagenta60, cls_gap_form, cls_gap_rem } from "style/index.css";
import { cls_align_items_center, cls_justify_content_flex_end, cls_justify_content_space_between } from "framework/structural_components/hbox_vbox.css";
import { Dialog, DialogContent, DialogTitle } from "framework/dialog/dialog";
import { useCountries } from "public_app/countries/store";
import { EventTechnicalInfo, TechnicalInfoKeysToCheck } from "./technical_info/view";
import { GetEditPermissions } from "./permissions";
import { EditPage } from "./editing";
import { EventCreationState } from "./event/event";
import { getIsoStringDate } from "framework/helpers";
var CancelEventDialog = function () {
    var _a = useEventPlanning_Event(), showCancelDialog = _a[0].showCancelDialog, actions = _a[1];
    return React.createElement(Dialog, { open: showCancelDialog },
        React.createElement(DialogContent, null,
            React.createElement(DialogTitle, null, "Zrušení soutěžní akce"),
            React.createElement(VBox, { className: cls_gap_form },
                React.createElement(HBox, { className: cls_gap_form }, "Opravdu chcete zrušit tuto soutěžní akci?"),
                React.createElement(HBox, { className: cls_gap_form }, "Tento krok nemůžete vzít zpět."),
                React.createElement(HBox, null),
                React.createElement(HBox, { className: [cls_gap_form, cls_justify_content_space_between] },
                    React.createElement(VBox, null,
                        React.createElement(Button, { className: cls_button_width, onClick: function () { actions.event_saveEvent(true, EventState.Cancelled); actions.event_hideCancelDialog(); }, intent: Intent.Negative }, "Ano, zrušit")),
                    React.createElement(VBox, null,
                        React.createElement(Button, { className: cls_button_width, onClick: function () { return actions.event_hideCancelDialog(); }, intent: Intent.NotAction }, "Ne"))))));
};
var ViewControl = function (props) {
    var _a, _b;
    var _c = useEventPlanning_Event(), store = _c[0], actions = _c[1];
    var _d = useUIContext(), loadEventPlanningUIContext = _d[1].loadEventPlanningUIContext;
    var eventId = props.eventId;
    // Event
    React.useEffect(function () {
        loadEventPlanningUIContext(Number(eventId));
        if (eventId != null) {
            actions.event_loadEvent(eventId);
        }
    }, [eventId]);
    // Competitions
    var competition_actions = useEventPlanning_Actions();
    React.useEffect(function () {
        if (eventId != null) {
            competition_actions.competitions_setEventId(eventId);
        }
    }, [eventId]);
    React.useEffect(function () {
        var compErrors = Object.entries(store.errors)
            .filter(function (x) { return x[0].startsWith('eventCompetitions[0].competitions'); })
            .map(function (x) { return ({ f: x[0].replace('eventCompetitions[0].competitions', ''), v: x[1] }); })
            .reduce(function (p, c) {
            var _a;
            return (__assign(__assign({}, p), (_a = {}, _a[c.f] = c.v, _a)));
        }, {});
        competition_actions.competitions_updateCompetitionErrors(compErrors);
    }, [store.errors]);
    // Officials
    var _e = useEventPlanning_Officials_AllOfficialsList(), all_officials_state = _e[0], officials_actions = _e[1];
    React.useEffect(function () {
        if (eventId != null) {
            officials_actions.officials_setEventId(eventId);
        }
    }, [eventId]);
    React.useEffect(function () {
        if (!all_officials_state.collection.length) {
            officials_actions.officials_loadAllOfficials();
        }
    }, []);
    var _f = useCountries(), countries_state = _f[0], countries_actions = _f[1];
    React.useEffect(function () {
        if (!countries_state.entity.length) {
            countries_actions.loadCountries();
        }
    }, []);
    // Technical info
    React.useEffect(function () {
        if (eventId != null) {
            actions.technicalInfo_loadConcurrentEvents();
        }
    }, [eventId, getIsoStringDate((_a = store.entity) === null || _a === void 0 ? void 0 : _a.dateFrom), getIsoStringDate((_b = store.entity) === null || _b === void 0 ? void 0 : _b.dateTo)]);
    return React.createElement(React.Fragment, null);
};
var View = function (props) {
    var _a, _b;
    var store = useEventPlanning_Event()[0];
    var selectedEditPage = useEventPlanning_Tabs()[0].selectedEditPage;
    var actions = useEventPlanning_Actions();
    var competition_actions = useEventPlanning_Actions();
    React.useEffect(function () {
        if (store.creationState !== EventCreationState.None) {
            actions.event_resetCreationState();
        }
    }, []);
    var entity = store.entity, errors = store.errors;
    var eventId = props.eventId;
    var tabEventBaseData = EditPage.EventBaseData.toString();
    var tabEventDetailedData = EditPage.EventDetailedData.toString();
    var tabCompetitions = EditPage.Competitions.toString();
    var tabOfficials = EditPage.Officials.toString();
    var tabTechnicalInfo = EditPage.TechnicalInfo.toString();
    var onValueChange = function (v) {
        actions.tabs_setPage(Number(v));
    };
    var saveChecked = function () {
        actions.event_saveEvent(true, EventState.Checked);
        competition_actions.competitions_setLastActionValidationToAllCompetitions();
    };
    var saveWaiting = function () { return actions.event_saveEvent(true, EventState.Waiting); };
    var saveApproved = function () { return actions.event_saveEvent(true, EventState.Approved); };
    var saveDisapprove = function () { return actions.event_saveEvent(true, EventState.Private); };
    var savePrivate = function () { return actions.event_saveEvent(true, EventState.Private); };
    var savePublic = function () { return actions.event_saveEvent(true, EventState.Public); };
    var eventState = entity.eventCompetitions.length > 0 ? entity.eventCompetitions[0].state : EventState.Private;
    var editPermissions = GetEditPermissions();
    var canBeChecked = editPermissions.a2_requestApproval && !store.checkPassed;
    var canBeWaited = editPermissions.a2_requestApproval && store.checkPassed;
    var canBeApproved = editPermissions.a4_approve;
    var canBeDisapproved = editPermissions.a5_disapprove;
    var canBeWithdrawn = editPermissions.a3_withdraw;
    var canBeReturned = editPermissions.a6_return;
    var canBeReady = editPermissions.a9_publish;
    var canBeCancelled = editPermissions.a7_cancel;
    var canBeRevived = editPermissions.a8_revive;
    var globalError = getFieldErrorsAsString(store, "");
    var officialErrors = (_a = errors['eventCompetitions[0].officials']) === null || _a === void 0 ? void 0 : _a.errors;
    var competitionErrors = (_b = errors['eventCompetitions[0].competitions']) === null || _b === void 0 ? void 0 : _b.errors;
    function checkIfAnyErrors(obj, keys) {
        var res = false;
        keys.forEach(function (k) {
            if (k in obj) {
                if (obj[k].errors) {
                    res = true;
                }
            }
        });
        return res;
    }
    function checkIfAnyCompetitionErrors(all_errors) {
        var res = false;
        var keys = Object.keys(all_errors);
        keys.forEach(function (k) {
            if (k.includes('eventCompetitions[0].competitions')) {
                res = true;
            }
        });
        return res;
    }
    var errorInEventBaseData = checkIfAnyErrors(errors, BaseDataKeysToCheck);
    var errorInEventDetailedInfo = checkIfAnyErrors(errors, DetailedDataKeysToCheck);
    var errorInOfficials = officialErrors && JSON.stringify(officialErrors) !== JSON.stringify({});
    var errorInCompetitions = checkIfAnyCompetitionErrors(errors);
    // const errorInCompetitions = competitionErrors && JSON.stringify(competitionErrors) !== JSON.stringify({});
    var errorInTechnicalInfo = checkIfAnyErrors(errors, TechnicalInfoKeysToCheck);
    var anyError = errorInEventBaseData || errorInEventDetailedInfo || errorInOfficials || errorInCompetitions || errorInTechnicalInfo;
    // React.useEffect(() => {
    //     console.log(errors);
    // }, [errorInEventBaseData, errorInEventDetailedInfo]);
    return React.createElement(VBox, { className: cls_gap_rem },
        React.createElement(ViewControl, { eventId: eventId }),
        eventId === entity.id ? React.createElement(React.Fragment, null,
            React.createElement(CancelEventDialog, null),
            React.createElement(HBox, { className: [cls_gap_rem, cls_justify_content_flex_end, cls_align_items_center] },
                anyError && React.createElement(HBox, { className: cls_colorMagenta60 }, "Propozice obsahují chyby. Opravte údaje v červeně podbarvených záložkách."),
                canBeChecked && React.createElement(Button, { onClick: saveChecked }, 'Zkontrolovat'),
                canBeWaited && React.createElement(Button, { onClick: saveWaiting }, 'Odeslat ke schválení'),
                canBeApproved && React.createElement(Button, { onClick: saveApproved }, 'Schválit'),
                canBeDisapproved && React.createElement(Button, { onClick: saveDisapprove }, eventState === EventState.Waiting ? 'Neschválit a poslat zpět' : 'Zrušit schválení a poslat zpět'),
                canBeWithdrawn && React.createElement(Button, { onClick: savePrivate }, eventState === EventState.Waiting ? 'Zrušit požadavek schválení a vzít zpět' : 'Zrušit schválení a vzít zpět'),
                canBeReturned && React.createElement(Button, { onClick: savePrivate }, 'Vrátit organizátorovi'),
                canBeReady && React.createElement(Button, { onClick: savePublic }, 'Zveřejnit'),
                canBeCancelled && React.createElement(Button, { onClick: actions.event_showCancelDialog, intent: Intent.NotAction }, 'Zrušit tuto soutěžní akci'),
                canBeRevived && React.createElement(Button, { onClick: savePrivate, intent: Intent.NotAction }, 'Obnovit tuto soutěžní akci')),
            React.createElement(Tabs, { value: selectedEditPage.toString(), onValueChange: onValueChange, onClick: actions.event_cancelCheck },
                React.createElement(TabsList, null,
                    React.createElement(TabsTrigger, { value: tabEventBaseData, containsError: errorInEventBaseData }, "Z\u00E1kladn\u00ED \u00FAdaje"),
                    React.createElement(TabsTrigger, { value: tabEventDetailedData, containsError: errorInEventDetailedInfo }, "Dal\u0161\u00ED \u00FAdaje"),
                    React.createElement(TabsTrigger, { value: tabOfficials, containsError: errorInOfficials }, "Odborn\u00ED pracovn\u00EDci"),
                    React.createElement(TabsTrigger, { value: tabCompetitions, containsError: errorInCompetitions }, "Sout\u011B\u017Ee"),
                    React.createElement(TabsTrigger, { value: tabTechnicalInfo, containsError: errorInTechnicalInfo }, "Technick\u00E1 data")),
                React.createElement(TabsContent, { value: tabEventBaseData, className: cls_form_area }, selectedEditPage.toString() == tabEventBaseData && React.createElement(EventEditBaseDataView, null)),
                React.createElement(TabsContent, { value: tabEventDetailedData, className: cls_form_area }, selectedEditPage.toString() == tabEventDetailedData && React.createElement(EventEditDetailedDataView, null)),
                React.createElement(TabsContent, { value: tabOfficials, className: cls_form_area }, selectedEditPage.toString() == tabOfficials && React.createElement(OfficialsEdit, null)),
                React.createElement(TabsContent, { value: tabCompetitions, className: cls_form_area }, selectedEditPage.toString() == tabCompetitions && React.createElement(CompetitionsEdit, { eventId: Number(eventId) })),
                React.createElement(TabsContent, { value: tabTechnicalInfo, className: cls_form_area }, selectedEditPage.toString() == tabTechnicalInfo && React.createElement(EventTechnicalInfo, null))),
            globalError && React.createElement(VBox, { className: cls_colorMagenta60 }, globalError)) : null);
};
export { View as PlanningEdit, };
